export function afterSpend(budget: Budget, record: RecordEntry): Budget {
  const spent = budget.spent + record.amount;
  return {...budget, spent};
}
